(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-data/error-code-handler/assets/javascripts/helpers/get-draw-amount-limit.js') >= 0) return;  svs.modules.push('/components/marketplace-data/error-code-handler/assets/javascripts/helpers/get-draw-amount-limit.js'); "use strict";

var getDrawAmountLimit = function getDrawAmountLimit(productId) {
  switch (productId) {
    case 1: 

    case 2: 

    case 7:
      return 60000;

    case 8: 

    case 23: 

    case 24: 

    case 25: 

    case 28:
      return 20000;

    default:
      return 0;
  }
};

setGlobal('svs.components.marketplaceData.errorCodeHandler.helpers.getDrawAmountLimit', getDrawAmountLimit);
 })(window);